module.exports = __webpack_public_path__ + "img/format_list_numbered.35544168.svg";